import { render, staticRenderFns } from "./RelatedOffers.vue?vue&type=template&id=28887e14&scoped=true"
import script from "./RelatedOffers.vue?vue&type=script&lang=js"
export * from "./RelatedOffers.vue?vue&type=script&lang=js"
import style0 from "./RelatedOffers.vue?vue&type=style&index=0&id=28887e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28887e14",
  null
  
)

export default component.exports